import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/SavedOrderList/Handlers/ToggleFiltersOpen";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Filter from "@ucs/Icons/Filter";
import UCSColors from "@ucs/Utils/UCSColors";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    toggleFiltersOpen,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & WidgetProps; 

export interface SavedOrderListContainerStyles {
    wrapper?: InjectableCss;
    container?: InjectableCss;
    filterSection?: InjectableCss;
    filters?: InjectableCss;
    orderLines?: InjectableCss;
    toggleFilterIcon?: IconPresentationProps;
    toggleFilterClickable?: ClickablePresentationProps;
}

export const savedOrderListContainerStyles: SavedOrderListContainerStyles ={
    wrapper: {
        css: css`            
            width: 100%;
            max-width: 1140px;
            margin: 0 auto;
            padding: 0 0px 96px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding: 0 20px 48px;
                    `,
                    css`
                        padding: 0 20px 48px;
                    `,
                ]);
            }}
        `
    },
    container: {
        css: css`            
            width: 100%;
            padding: 20px;
            background-color: ${UCSColors.gray10};
            box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding: 20px 10px;
                    `,
                    css`
                        padding: 20px 10px;
                    `,
                ]);
            }}
        `
    },
    filterSection:{
        css: css`
            width: 100%;
            min-height: 27px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 15px;
        `
    },
    toggleFilterIcon: {
        src: Filter,
        size: 16,
        color: "primary",
        css: css`
            margin-right: 8px;
        `
    },
}

const styles = savedOrderListContainerStyles;

const SavedOrderListContainer: React.FC<Props> = ({toggleFiltersOpen, id, ...props}) => {
    
    useEffect(() => {
        toggleFiltersOpen();
    }, [])

    return <StyledWrapper {...styles.wrapper}>
        <StyledWrapper {...styles.container}> 
            <Hidden below="md" style={{ width: "100%" }}>
                <StyledWrapper {...styles.filterSection}>
                    <Clickable
                        {...styles.toggleFilterClickable}
                        onClick={toggleFiltersOpen}
                        data-test-selector="savedOrderList_showHideFilters"
                    >
                        <Icon {...styles.toggleFilterIcon} /> 
                        <Typography size={18} color={UCSColors.gray03}>{translate("Filter")}</Typography>
                    </Clickable>
                <Zone contentId={id} zoneName="TopSection" />
                </StyledWrapper>   
            </Hidden>

            <Zone contentId={id} zoneName="MainSection" />
        </StyledWrapper>
        <Zone contentId={id} zoneName="BottomSection" />

    </StyledWrapper>
}

const savedOrderListContainer: WidgetModule = {
    component: connect(null, mapDispatchToProps)(SavedOrderListContainer),
    definition: {
        group: "Saved Order List",
    },
};

export default savedOrderListContainer;